import { useTranslation } from 'react-i18next';
import { useOnboarding } from '../OnboardingContext';
import { Building2, User } from 'lucide-react';

export function AccountTypeStep() {
  const { t } = useTranslation();
  const { updateData, setCurrentStep } = useOnboarding();

  const handleSelectType = (type: 'individual' | 'corporate') => {
    updateData({ accountType: type });
    // Individual flow starts with phone verification
    // Corporate flow starts with company search (company-first approach)
    if (type === 'corporate') {
      setCurrentStep('corporate-company-search');
    } else {
      setCurrentStep('phone');
    }
  };

  return (
    <div className="min-h-screen-safe bg-background flex flex-col items-center justify-center p-4 sm:p-6 safe-area-inset-top safe-area-inset-bottom">
      <div className="w-full max-w-md animate-fade-in-up px-2">
        <h1 className="text-2xl sm:text-3xl font-bold text-center mb-2 sm:mb-3">
          {t('accountType.title')}
        </h1>
        <p className="text-sm sm:text-base text-muted-foreground text-center mb-6 sm:mb-8">
          {t('accountType.subtitle')}
        </p>

        <div className="space-y-3 sm:space-y-4">
          <button
            onClick={() => handleSelectType('individual')}
            className="w-full p-4 sm:p-6 rounded-2xl border-2 border-border bg-card hover:border-accent active:border-accent hover:bg-accent/10 active:bg-accent/15 transition-all duration-300 group text-left touch-manipulation"
            style={{ minHeight: '88px' }}
          >
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-accent/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors flex-shrink-0">
                <User className="w-5 h-5 sm:w-6 sm:h-6 text-accent" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-lg font-semibold mb-1">{t('accountType.individual')}</h3>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  {t('accountType.individualDesc')}
                </p>
              </div>
            </div>
          </button>

          <button
            onClick={() => handleSelectType('corporate')}
            className="w-full p-4 sm:p-6 rounded-2xl border-2 border-border bg-card hover:border-accent active:border-accent hover:bg-accent/10 active:bg-accent/15 transition-all duration-300 group text-left touch-manipulation"
            style={{ minHeight: '88px' }}
          >
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-accent/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors flex-shrink-0">
                <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-accent" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-lg font-semibold mb-1">{t('accountType.corporate')}</h3>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  {t('accountType.corporateDesc')}
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
